import { BaseDevice, CustomLayout } from '../../base_device'
import { generateArray } from '@/tool/utility'
import { getDeviceKeySquare } from '../keysquare/keysquare'
import { DevicePid, EffectIndex, KK } from '@/define/define'
import list_icon from '@/assets/img/device/na87/list_icon.png'
import { na87VKCodes } from '../keycode/vkeycode'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { LIGHT_EFFECT_LIST_IROKN_ST } from '../../light/light_effect_list'

export class NA87 extends BaseDevice {
  speedAllowValues: number[] = generateArray(0, 5)
  lightAllowValues: number[] = generateArray(0, 5)
  magneticAxis: boolean = true
  square = getDeviceKeySquare(DevicePid.IROKNA87)
  resetDes: string = ''

  minDelayTimer: number = 1
  maxDelayTimer: number = 60000

  name: string = 'NA87'
  icon: string = list_icon
  width: number = 770
  y_number: number = 10
  inoperableKeys: KK[] = [0x50b]
  fnDisableKeys: KK[] = [0x0002, 0x0003, 0x0004, 0x0005, 0x0007, 0x0008, 0x0009, 0x000a, 0x000b, 0x000c, 0x000d, 0x000e, 0x0010, 0x010f, 0x020f, 0x0302, 0x0303, 0x0410, 0x0501, 0x050f, 0x0510, 0x0511]
  vkcodes = na87VKCodes
  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_IROKN_ST

  customLayout: CustomLayout = {
    0x02: this.createSquare(59.6, 2),
    0x07: this.createSquare(8, 2),
    0x0b: this.createSquare(8, 2),
    0x0f: this.createSquare(8, 2),
    0x100: this.createSquare(2, this.y_number),
    0x101: this.createSquare(2, this.y_number),
    0x102: this.createSquare(2, this.y_number),
    0x103: this.createSquare(2, this.y_number),
    0x104: this.createSquare(2, this.y_number),
    0x105: this.createSquare(2, this.y_number),
    0x106: this.createSquare(2, this.y_number),
    0x107: this.createSquare(2, this.y_number),
    0x108: this.createSquare(2, this.y_number),
    0x109: this.createSquare(2, this.y_number),
    0x10a: this.createSquare(2, this.y_number),
    0x10b: this.createSquare(2, this.y_number),
    0x10c: this.createSquare(2, this.y_number),
    0x10e: this.createSquare(2, this.y_number, 66),
    0x10f: this.createSquare(10, this.y_number),
    0x110: this.createSquare(2, this.y_number),
    0x111: this.createSquare(2, this.y_number),
    0x200: this.createSquare(2, 2, 46),
    0x20e: this.createSquare(2, 2, 60),
    0x20f: this.createSquare(10, 2),
    0x300: this.createSquare(2, 2, 55),
    0x30e: this.createSquare(2, 2, 91.5),
    0x400: this.createSquare(2, 2, 76),
    0x40e: this.createSquare(2, 2, 112.3),
    0x410: this.createSquare(53, 2),
    0x500: this.createSquare(2, 2, 54.1),
    0x501: this.createSquare(2, 2, 54.1),
    0x502: this.createSquare(2, 2, 54.1),
    0x506: this.createSquare(2, 2, 257),
    0x50a: this.createSquare(2, 2, 54.1),
    0x50f: this.createSquare(10, 2),
  }
  // win按键锁定
  lockWin: boolean = true
  // 回报率
  rate: number[] = [1, 2, 4, 8]
}
